export default {
  'h_one': 'Chain Explorer',
  'tit_one': 'Block',
  'tit_two': 'NFT',
  'HyperchainSpaceHeight': 'Hyper Block Height',
  'SpaceHeight':'Height',
  'Nodes': 'Nodes',
  'NodeMap': 'NodeMap',
  'Blockchains': 'Localchains',
  'Concurrency': 'Concur Peak',
  'HBlock': 'HBlock',
  'LChains': 'LChains',
  'Search': 'Search',
  'Tips': 'Example: "11633" for Hyperblock searching; "11633,2" for LocalChain; "11633,2,5" for LocalBlock.',
  'Time': 'Time',
  'Blocks': 'Blocks',
  'Chains': 'Chains',
  'Next': 'Next',
  'Previous': 'Previous',
  'HyperBlock': 'HyperBlock',
  'LocalBlockId': 'LocalBlockId',
  'Localchains': 'Localchains',
  'BlockSize': 'Block Size',
  'BlockVersion': 'Block Version',
  'BlockHash': 'Block Hash',
  'PreviousBlockHash': 'Previous Block Hash',
  'Consensus': 'Consensus',
  'Difficulty': 'Weight',
  'Height': 'Height',
  'Size': 'Size',
  'Ver': 'Ver',
  'Payload': 'Payload',
  'Localchain': 'Localchain',
  'LocalBlock': 'Local Block',
  'PreviousLocalBlock': 'Previous Local Block',
  'PreviousLocalBlockHash': 'Previous Local Block Hash',
  'HyperblockHash': 'Hyperblock Hash',
  'RAW': 'Local Block Payload in RAW Format',
  'PayloadHash': 'Payload Hash',
  'PayloadSize': 'Payload Size',
  'More': 'More',
  'Fewer': 'Fewer',
  'Help': 'Help',
  'HyperBlockList': 'HyperBlock List',
  'LocalChainList': 'LocalChain List',
  'LocalBlockList': 'LocalBlock List',
  'LocalchainType': 'Localchain Type',
  'DApp': 'DApp',
  'HyperBlockMsg': 'HyperBlock',
  'LocalChainMsg': 'LocalChain',
  'LocalBlockMsg': 'LocalBlock',
  'Top':'Top',
  'mainnet_default': 'Not yet, please wait',
  'PreviousHyperBlock_hash': 'Previous Hyper Block Hash',
  'tx':'Transaction',
  'AppType': 'App Type',
  'T_token': 'Token',
  'T_coin': 'Coin',
  'T_default': 'Default',
  'Apps':'Apps',
  'AppName':'App Name',
  'PayloadRaw': 'Payload Raw',
  'PayloadParsed': 'Payload Parsed',
  'P_default': 'Unregnized Data Format,Require Data Parser',
  'NFT_key1': 'Active Addresses',
  'NFT_key2': ' Transactions last 24h',
  'NFT_key3': 'NFTs Minted',
  'NFT_placeholder': 'Enter Collection number/Collection hash/Transaction hash',

  node_map: {
    sidebarTitle: 'Node State',
    MoreBtnText: 'More Network Info',

    OffLine: 'Off line',
    Synchronizing: 'Synchronizing',
    Idle: 'Idle',
    LocalConsensus: 'In Local Consensus',
    GlobalConsensus: 'in Global Consensus',
    Success: 'Success',
    Exception: 'Exception',
    Suspect: 'Suspect',

    HyperblockHight: 'Hyperblock Height',
    NodesNum: 'Nodes',
    Peak: 'Peak Today',
    TPS: 'TPS',
    NextHyperblock: 'Next Hyperblock',

    NewNodeNumText: 'NEW: ',
  }
}